import { createSlice, current } from '@reduxjs/toolkit'

const initialState = {
  success: '',
  hasNext: false,
  page: 0,
  hasPrev: false,
  totalPages: 0,
  totalResult: 0,
  loading: false,
  prescriptions: [],
  prescriptionInfo: {},
  error: '',
  processing: false,
  loader: false,
  address: {},
  currentTab: {},
  resetPage: false,
}

const prescriptionSlice = createSlice({
  name: 'prescriptionSlice',
  initialState: initialState,
  reducers: {
    getViberPrescription: () => {},
    updateName: () => {},
    createOrder: () => {},
    getScannedPrescriptionOrder: () => {},
    getPharmacyPrescription: () => {},
    createPrescriptions: () => {},
    sendQuotation: () => {},
    confirmOrder: () => {},
    cancelOrder: () => {},
    deletePrescription: () => {},
    updateAddress: () => {},
    removePrescriptionFromList: (state, action) => {
      if (state?.prescriptionInfo?.prescription) {
        state.prescriptionInfo = {
          ...state.prescriptionInfo,
          prescriptions: [
            ...state.prescriptionInfo?.prescription,
            ...current(state.prescriptionInfo?.prescriptions).filter(
              (prescription) =>
                prescription.id !== action.payload.prescriptionId,
            ),
          ],
        }
      } else {
        state.prescriptionInfo = {
          ...state.prescriptionInfo,
          prescriptions: [
            ...state.prescriptionInfo?.prescriptions.filter(
              (prescription) =>
                prescription.id !== action.payload.prescriptionId,
            ),
          ],
        }
      }
    },
    addAddress: () => {},
    setPrescription: (state, action) => {
      const { data, page, total_results, total_pages } = action.payload
      state.prescriptions = data
      state.page = page
      state.totalResult = total_results
      state.totalPages = total_pages
      state.loading = false
    },
    setPrescriptionInfo: (state, action) => {
      state.loading = false
      state.prescriptionInfo = action.payload
    },
    setNewPrescription: (state, action) => {
      state.prescriptionInfo = {
        ...state.prescriptionInfo,
        prescriptions: [
          ...state.prescriptionInfo?.prescriptions,
          action.payload,
        ],
      }
    },
    setUpdatedOrder: (state, action) => {
      state.prescriptions = state.prescriptions.map((prescription) =>
        prescription.id === action.payload.id
          ? { ...prescription, ...action.payload }
          : prescription,
      )
    },
    removeOrderFromList: (state, action) => {
      state.prescriptions = state.prescriptions.filter(
        (prescription) =>
          prescription.id !==
          (action.payload.bot_message_id ?? action.payload.prescriptionId),
      )
      state.totalResult = parseInt(state.totalResult) - 1
    },
    setLoading: (state) => {
      state.loading = true
      state.error = ''
    },
    setAddress: (state, action) => {
      state.address = action.payload
      state.prescriptionInfo.requested_for.address = [ action.payload, ...state.prescriptionInfo?.requested_for?.address]
    },
    setLoader: (state, action) => {
      state.loader = action.payload ?? true
      state.error = ''
    },
    setError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true
      state.error = ''
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload
    },
    setResetPage: (state, action) => {
      state.resetPage = action.payload
    },
    clearFormData:(state) => {
      state.prescriptionInfo = {}
      state.prescriptions = {}
      state.address = {}
    }
  },
})

export const {
  getViberPrescription,
  getScannedPrescriptionOrder,
  getPharmacyPrescription,
  deletePrescription,
  sendQuotation,
  confirmOrder,
  cancelOrder,
  removePrescriptionFromList,
  addAddress,
  updateAddress,
  createPrescriptions,
  updateName,
  createOrder,
  setPrescription,
  setUpdatedOrder,
  setNewPrescription,
  setAddress,
  setLoader,
  setPrescriptionInfo,
  removeOrderFromList,
  setLoading,
  setProcessing,
  setError,
  setResetPage,
  clearFormData
} = prescriptionSlice.actions

export default prescriptionSlice.reducer
